const supportedLanguages = ['es', 'en'] as const;
type SupportedLanguages = typeof supportedLanguages[number];

export type { SupportedLanguages };
export { supportedLanguages };
